/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateInvoiceIssuerDto
 */
export interface CreateUpdateInvoiceIssuerDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateInvoiceIssuerDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateInvoiceIssuerDto
     */
    address?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateInvoiceIssuerDto
     */
    nip?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateInvoiceIssuerDto
     */
    bankName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateInvoiceIssuerDto
     */
    bankAccount?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateInvoiceIssuerDto
     */
    note?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateInvoiceIssuerDto
     */
    footer?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateInvoiceIssuerDto
     */
    symbol?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateInvoiceIssuerDto
     */
    symbolCorrection?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateInvoiceIssuerDto
     */
    krd: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateInvoiceIssuerDto
     */
    active: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateInvoiceIssuerDto
     */
    isDefault: boolean;
}

/**
 * Check if a given object implements the CreateUpdateInvoiceIssuerDto interface.
 */
export function instanceOfCreateUpdateInvoiceIssuerDto(value: object): value is CreateUpdateInvoiceIssuerDto {
    if (!('krd' in value) || value['krd'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    if (!('isDefault' in value) || value['isDefault'] === undefined) return false;
    return true;
}

export function CreateUpdateInvoiceIssuerDtoFromJSON(json: any): CreateUpdateInvoiceIssuerDto {
    return CreateUpdateInvoiceIssuerDtoFromJSONTyped(json, false);
}

export function CreateUpdateInvoiceIssuerDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateInvoiceIssuerDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'address': json['address'] == null ? undefined : json['address'],
        'nip': json['nip'] == null ? undefined : json['nip'],
        'bankName': json['bankName'] == null ? undefined : json['bankName'],
        'bankAccount': json['bankAccount'] == null ? undefined : json['bankAccount'],
        'note': json['note'] == null ? undefined : json['note'],
        'footer': json['footer'] == null ? undefined : json['footer'],
        'symbol': json['symbol'] == null ? undefined : json['symbol'],
        'symbolCorrection': json['symbolCorrection'] == null ? undefined : json['symbolCorrection'],
        'krd': json['krd'],
        'active': json['active'],
        'isDefault': json['isDefault'],
    };
}

export function CreateUpdateInvoiceIssuerDtoToJSON(value?: CreateUpdateInvoiceIssuerDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'address': value['address'],
        'nip': value['nip'],
        'bankName': value['bankName'],
        'bankAccount': value['bankAccount'],
        'note': value['note'],
        'footer': value['footer'],
        'symbol': value['symbol'],
        'symbolCorrection': value['symbolCorrection'],
        'krd': value['krd'],
        'active': value['active'],
        'isDefault': value['isDefault'],
    };
}

